import { type SxProps, type Theme } from "@mui/material/styles";

import { SUBMENU_CHEVRON_SIZE } from "ui/actions-menu/submenu-item/submenu-item.constants";

/** The wrapper `ActionsMenu` puts around its trigger is a centred flex box; the row has to fill it. */
export const WRAPPER_SX: SxProps<Theme> = { width: "100%" };

export const CHEVRON_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexShrink: 0,
  color: theme.palette.text.secondary,
  "& > svg": { width: SUBMENU_CHEVRON_SIZE, height: SUBMENU_CHEVRON_SIZE },
});
